import type {
	AssistantChartDataId,
	AssistantChartImageId,
	AssistantConversationId,
	Relations,
	SuretyAccountId,
} from "@inrev/common";

export const assistantEnabledQueryKey = ["assistant", "enabled"] as const;

export const assistantConversationQueryKey = (conversationId?: AssistantConversationId) =>
	conversationId
		? (["assistant", "conversations", conversationId] as const)
		: (["assistant", "conversations"] as const);

export const assistantCitationsQueryKey = (
	conversationId: AssistantConversationId | undefined,
	evidenceIds: readonly string[],
) => ["assistant", "conversations", conversationId ?? null, "citations", ...evidenceIds] as const;

/**
 * Under the conversations prefix, so invalidating every conversation refreshes the list too. Without
 * an account it matches every account's list, for callers that only know a conversation.
 */
export const assistantConversationsQueryKey = (accountId?: SuretyAccountId) =>
	accountId
		? (["assistant", "conversations", "account", accountId] as const)
		: (["assistant", "conversations", "account"] as const);

/**
 * Outside the conversation's key on purpose: each finished turn invalidates that whole prefix, and
 * a stored chart never changes, so nesting it there would refetch every chart on screen.
 */
export const assistantChartImageQueryKey = (imageId: AssistantChartImageId) =>
	["assistant", "charts", imageId] as const;

/** Beside the images, for the same reason. */
export const assistantChartDataQueryKey = (chartId: AssistantChartDataId) =>
	["assistant", "chart-data", chartId] as const;

export const assistantConversationStorageKey = (relation: Relations.Notes) =>
	`assistant.conversation.${relation.relationType}.${relation.relationId}`;
